import React, { useEffect, useState } from "react";
import { Outlet, useNavigate } from "react-router-dom";

function getUserRole() {
  try {
    const token = localStorage.getItem("token");
    if (!token) return null;
    const payload = JSON.parse(atob(token.split(".")[1]));
    // JWT payload: { id, roleId: { id, name } }
    if (payload.roleId && typeof payload.roleId === "object") {
      return payload.roleId.name || null;
    }
    // Fallback for legacy tokens
    return payload.role || null;
  } catch {
    return null;
  }
}

const RequireAdmin = () => {
  const [checked, setChecked] = useState(false);
  const [isAdmin, setIsAdmin] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const role = getUserRole();
    if (!role) {
      // No token or invalid token
      if (typeof window !== "undefined" && window.showInvalidTokenMessage) {
        window.showInvalidTokenMessage();
      } else {
        navigate("/login", { replace: true });
      }
      setIsAdmin(false);
    } else if (role.toLowerCase() !== "admin") {
      // Not admin
      navigate("/unauthorized", { replace: true });
      setIsAdmin(false);
    }
    setChecked(true);
  }, [navigate]);

  if (!checked) return null;
  if (!isAdmin) return null;
  return <Outlet />;
};

export default RequireAdmin;
